import React from 'react'
import Navbar from "./Navbar"
import Categories from "./Categories"
import Card from './Card'
import Footer from './Footer'
import "../css/home.css"
import { useEffect, useState } from 'react';
import axios from 'axios';
import { NavLink } from 'react-router-dom'
import image from "../images"



function Home() {

  
      
      const [searchInput, setSearchInput] = useState('');
      const [location, setLocation] = useState('');
      const [message, setMessage] = useState("");
      const [searchResults, setSearchResults] = useState([]);
      
      
      const handleSearch = async () => {
        try {
          const response = await axios.post(`https://petme.onrender.com/api/pets/search`, { searchInput, location });
          setSearchResults(response.data);
          if(response.data.length === 0){
            setMessage("Pet not found")
         }else{
           setMessage("")
         }
          } catch (error) {
            console.error(error);
          }
        };

  useEffect(()=>{
    handleSearch()
    },[searchInput,location])



  return (
    <div>
      <Navbar/>
      <div className="filter">

        <form action="" className="searchbar">
          <i class="fa-solid fa-paw search-paw"></i>
          <input type="text" name="search" className="search-pet-box" onChange={(e) => { setSearchInput(e.target.value) }} placeholder="search cat, dog, breed, etc..." />
          <h4 className="search-line">|</h4>
          <i id="search-location-icon" className="searchbar-locationIcon fa-solid fa-location-dot"></i>
          <input type="text" name="search" className="search-location-box" onChange={(e) => { setLocation(e.target.value) }} placeholder="enter city or pincode..." />

        </form>

        {/* Donation Btn */}

        <NavLink className="searchBar-donationBtn-link" to="/supportus" >
          <button className="searchBar-donationBtn">SUPPORT US<img className="searchBar-donationImg" src={image.donationImg} alt="animals-profile" /></button>
        </NavLink>

      </div>
      {!searchInput && !location && (
        <>
            <div className="homePage-introDiv">
                <div className="homePage-textDiv">
                    <div className="homePage-quoteDiv">
                        <h2 className="discover-friend" >DISCOVER YOUR<br />FOREVER FRIEND <br />Here.</h2>
                    </div>
                    <div className="homePage-msgDiv">
                        <h3 className="home-msg" >Connect with us and find your Furry Soul Mate waiting for you just around the corner.</h3>
                    </div>
                </div>
            </div>

        </>
      )}

      <Categories />
      <h3 className="nearby-adoption"> Pets <span className="nearby">Nearby </span> Are Waiting For <span className="adoption">Adoption</span></h3>

     {/* Animal Card */}

      <section id="animal">
      {message && (<h1 style={{opacity: 0.5,textAlign: 'center',}}>{message}</h1>)}
        <div className="row card-row">
          {searchResults.slice(0, 6).map((pet) => (
            <div key={pet.id} className="animal-box col-lg-2 col-md-4 col-sm-6">
              <Card pet={pet} />
            </div>
          ))}
        </div>
      </section>

      <div className="donate-pet-div">
        <div className="donatePet-div-msg">
          {/* <p className="donatePet-msg">In the act of self-sacrifice, you enable a beautiful transformation, allowing your loyal companion to find happiness, comfort, and unwavering love in the arms of their new adoptive family.</p> */}
          <p className="donatePet-quote">Every pet deserves a loving home. Be the bridge that connects them to happiness.</p>
          <div className="donatePetBtn-div">
            <NavLink className="donate-pet-btn-link" to="/petData" >
              <button className="donate-pet-btn">DONATE PET<img className="home-donatePetImg" src={image.dog_house} alt="dog-house" /></button>
            </NavLink>
          </div>
        </div>
      </div>

      <Footer />

    </div>
  )
}

export default Home